import React, { useEffect, useState, useRef } from "react"
import Modal from 'react-modal';
import Menu from '@components/Menu/index';
import { SoundOnIcon, SoundOffIcon, MicOnIccon, MicOffIcon, HeadLightsOffIcon, HeadLightsOnIcon, ArrowDrowUp, ArrowDrowDown, PlusVolumeIcon, MinusVolumeIcon } from '@util/svgicon';
import RobotGeneralDetails from "./RobotGeneralDetails";
import { useSelector, useDispatch } from "react-redux";
import * as actionTypes from '@redux/actionTypes';
import { mute } from "../Drivepanel/RobotSendData";
import { safeLocalStorage } from "@utils/localstorage";
let keyboradKeyInterval;
let pressedKeys = {};
const customStyles = {
    content: {
        top: '0%',
        right: '0%',
        left: '0%',
        bottom: '0%',
        borderRadius: '0%',
        border: '0%',
        padding: '0%',
        margin: '0%',
        opacity: '0.9',
        background: '#000000',
        width: '100%',
        height: '100%',
    },
};

const Topheader = () => {
    const dispatch = useDispatch()
    const audioRef = useRef(null);
    const keyboradKey = safeLocalStorage.getItem(`keyboradKey`)
    const headlight = useSelector((state) => state.sound.headlight)
    const mic = useSelector((state) => state.sound.mic)
    const audio = useSelector((state) => state.sound.audio)
    const checkPointAchieve = useSelector((state) => state.checkPointAchieve.achievePoint)
    const lastCheckPoint = useSelector((state) => state.checkPointAchieve.lastCheckPoint)
    const modalIsOpen = useSelector((state) => state.testDriveDetails.modalIsOpen);
	const rulesOpenModel = useSelector((state) => state.loadingSpinner.ruleModel);
  const testDriveComplect = useSelector((state) => state.testDriveDetails.testDriveComplect);
    const [volume, setVolume] = useState(25);
    const [showVolume, setShowVolume] = useState(false)
    const storedHeadlight = safeLocalStorage.getItem('headlight') === 'true';
    const [headlightLocalStorage, setHeadlightLocalStorage] = useState(storedHeadlight);

    useEffect(() => {
        safeLocalStorage.setItem('headlight', headlightLocalStorage.toString());
    }, [headlightLocalStorage]);

    useEffect(() => {
        if (keyboradKey) {
            keyboradKeyInterval = setInterval(() => {
                const token = safeLocalStorage.getItem('token')
                const keyBinding = safeLocalStorage.getItem(`keyBinding_${token?.user?.id}`)
                window.addEventListener('keydown', handleKeyDown);
                window.addEventListener('keyup', handleKeyUp);
                keyboardControlHandeler(keyBinding)
            }, 200)
        }
        return () => {
            clearInterval(keyboradKeyInterval)
        }
    }, [])

    const keyboardControlHandeler = async (keyBinding) => {
        if (keyBinding && pressedKeys[keyBinding[`Toggle Headlights`]]) {
            toogleHeadLightKeyboard();
        }
    }

    const handleKeyDown = (event) => {
        pressedKeys[event.key] = true;
    };

    const handleKeyUp = (event) => {
        pressedKeys[event.key] = false;
    };

    const openModal = () => {
        dispatch({
            type: actionTypes.MENU_OPEN_MODEL,
            payload: false
        })
        dispatch({
            type: actionTypes.HIDE_MENU,
            payload: false
        })
    }

    const openGoBackModal = () => {
        dispatch({
            type: actionTypes.MENU_OPEN_MODEL,
            payload: true
        })
        dispatch({
            type: actionTypes.HIDE_MENU,
            payload: true
        })
    }

    const volumePlusMinus = (event) => {
        // document.getElementById("myinput").oninput = function () {
        //     var value = (this.value - this.min) / (this.max - this.min) * 100
        //     setVolume(value)
        // };
        const el = document.getElementById("myinput")
        if (volume === 25) {
            el.style.background = 'linear-gradient(to right, #82CFD0 0%, #82CFD0 25%, #fff 50%, white 100%)'
        } else {
            el.style.background = 'linear-gradient(to right, #82CFD0 0%, #82CFD0 ' + volume + '%, #fff ' + volume + '%, white 100%)'
        }
        setVolume(event.target.valueAsNumber)
        let audioElm = document.getElementById('microphone');
        if (audioElm) {
            audioElm.volume = event.target.valueAsNumber / 100
        }
    }

    useEffect(() => {
        let audioElm = document.getElementById('microphone');
        if (audioElm && audioElm.volume) {
            audioElm.volume = 25 / 100
        }
    }, [])

    const togglePlusVolume = () => {
        const el = document.getElementById("myinput")
        el.style.background = 'linear-gradient(to right, #82CFD0 0%, #82CFD0 ' + volume + '%, #fff ' + volume + '%, white 100%)'
        setVolume(volume < 100 ? volume + 1 : volume)
    }

    const toggleMinusVolume = () => {
        const el = document.getElementById("myinput")
        el.style.background = 'linear-gradient(to right, #82CFD0 0%, #82CFD0 ' + volume + '%, #fff ' + volume + '%, white 100%)'
        setVolume(volume > 1 ? volume - 1 : volume)
    }

    const toggleVolumeArrow = () => {
        setShowVolume(!showVolume)
    }

    const toggleVolume = async () => {
        let audioElm = document.getElementById('microphone');
        audioElm.muted = await audio;
        if (audio) {
            dispatch({
                type: actionTypes.AUDIO_MUTED,
                payload: false
            })
            audioRef?.current?.play()
        } else {
            dispatch({
                type: actionTypes.AUDIO_MUTED,
                payload: true
            })
            audioRef?.current?.pause()
        }
    }

    const toggleMic = async () => {
        const muteVal = await mute(mic)
        if (muteVal) {
            dispatch({
                type: actionTypes.MIC_MUTED,
                payload: false
            })
        } else {
            dispatch({
                type: actionTypes.MIC_MUTED,
                payload: true
            })
        }
    }

    const toogleHeadLight = async () => {
        if (headlight) {
            dispatch({
                type: actionTypes.HEAD_LIGHT,
                payload: false
            })
        } else {
            dispatch({
                type: actionTypes.HEAD_LIGHT,
                payload: true
            })
        }
    }

    const toogleHeadLightKeyboard = async () => {
        setHeadlightLocalStorage(prevState => !prevState);
    };

    return (
        <div className="testdrive-top-head" style={{
            backgroundImage: (checkPointAchieve || lastCheckPoint) && "linear-gradient(180deg, #25BD66, transparent)",
            zIndex: (rulesOpenModel || testDriveComplect) ? 0 : 1
        }}>
            <div className="top-left-container">
                <div className="top-left-hud-play">
                    <div id={modalIsOpen ? 'menu-off' : "menu-on"} className={`menu-container ${modalIsOpen ? 'menu-back' : ''}`} >
                        <div className={`caption ${modalIsOpen ? 'black' : ''}`}>
                            {modalIsOpen ?
                                <button onClick={openModal}>
                                    <p>Go back</p>
                                </button>
                                :
                                <button className="menu-btn-container" onClick={openGoBackModal}>
                                    <div className="menu-start-container">
                                        <p className="start-letter">START</p>
                                        <p className="rectangel_icon"></p>
                                    </div>
                                    <p className="menu-letter">Menu</p>
                                </button>
                            }
                        </div>
                    </div>
                    <RobotGeneralDetails />
                </div>
            </div>
            <div className="top-right-hud-play">
                <div className="headlight-indicator">
                    <div className="hud-indicator">
                        <p className="light-letter">Lights</p>
                    </div>
                    {headlight || headlightLocalStorage ? (
                        <>
                            <div className="mic-on w-embed" onClick={keyboradKey ? toogleHeadLightKeyboard : toogleHeadLight}>
                                <HeadLightsOnIcon />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="mic-off w-embed" onClick={keyboradKey ? toogleHeadLightKeyboard : toogleHeadLight}>
                                <HeadLightsOffIcon />
                            </div>
                        </>
                    )}
                </div>
                <div className="mic-indicator">
                    <div className="hud-indicator">
                        <p className="mic-letter">Mic</p>
                    </div>
                    {!mic ? (
                        <>
                            <div className="mic-on w-embed" onClick={toggleMic}>
                                <MicOnIccon />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="mic-off w-embed" onClick={toggleMic}>
                                <MicOffIcon />
                            </div>
                        </>
                    )}
                </div>
                <div className="audio-indicator">
                    <div className="hud-indicator">
                        <div className="dropdown">
                            <button className="audio-letter" onClick={toggleVolumeArrow}>Audio</button>
                        </div>
                    </div>
                    <div className="hud-indicator-volume">
                        {audio ? (
                            <>
                                <div className="sound-on w-embed" onClick={toggleVolume}>
                                    <SoundOnIcon />
                                </div>
                                <div className="dropdown">
                                    <div className="hud-indicator-volume">
                                        <button className="caption-audio" onClick={toggleVolumeArrow}><ArrowDrowUp /></button>
                                    </div>
                                    {
                                        showVolume &&
                                        <div className="dropdown-content" style={audio ? { display: 'block' } : { display: 'none' }} >
                                            <div id="device-test" className="device_test" >
                                                <div className="plusvolume" onClick={togglePlusVolume}>
                                                    <PlusVolumeIcon />
                                                </div>
                                                <input
                                                    type="range"
                                                    min={0}
                                                    max={100}
                                                    step={0.02}
                                                    value={volume}
                                                    onChange={volumePlusMinus}
                                                    id="myinput"
                                                    style={{ background: `linear-gradient(to right, #82CFD0 0%, #82CFD0 ${volume}%, #fff ${volume}%, white 100%)` }}
                                                />
                                                <div className="minusvolume" onClick={toggleMinusVolume}>
                                                    <MinusVolumeIcon />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="sound-off w-embed" onClick={toggleVolume}>
                                    <SoundOffIcon />
                                </div>
                                <div className="dropdown">
                                    <div className="hud-indicator-volume">
                                        <button className="caption-audio" onClick={toggleVolumeArrow}><ArrowDrowDown /></button>
                                    </div>
                                    {showVolume &&
                                        <div className="dropdown-content" style={audio ? { display: 'block' } : { display: 'none' }} >
                                            <div id="device-test" className="device_test" >
                                                <div className="plusvolume" onClick={togglePlusVolume}>
                                                    <PlusVolumeIcon />
                                                </div>
                                                <input
                                                    type="range"
                                                    min={0}
                                                    max={100}
                                                    step={0.02}
                                                    value={volume}
                                                    onChange={volumePlusMinus}
                                                    id="myinput"
                                                />
                                                <div className="minusvolume" onClick={toggleMinusVolume}>
                                                    <MinusVolumeIcon />
                                                </div>
                                            </div>
                                        </div>}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <Modal
                isOpen={modalIsOpen}
                style={customStyles}
                ariaHideApp={false}
            >
                <Menu />
            </Modal>
        </div>
    )
}

export default Topheader;
